import { render, staticRenderFns } from "./TasksCounter.vue?vue&type=template&id=786c7d84&scoped=true"
import script from "./TasksCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TasksCounter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TasksCounter.vue?vue&type=style&index=0&id=786c7d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786c7d84",
  null
  
)

export default component.exports